import { useTranslation } from 'react-i18next';
import { changeQuantity, removeProduct } from '../sagas/sagaActions';
import { billingCadence, licenseTypeLabel } from '../shared/catalogLabels';
import styles from '../shared/checkoutLayout.module.scss';
import { PriceTag, QuantityField, RemoveButton } from '../shared/primitives';
import { productIcon, productIconColor } from '../shared/productIcon';
import {
  type CartProductView,
  selectCartProducts,
} from '../store/cartSelectors';
import { useAppDispatch, useAppSelector } from '../store/hooks';

function ProductOverviewCard({ view }: { view: CartProductView }) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  return (
    <div className={styles.poCard}>
      <img
        className={styles.poLogo}
        src={productIcon(view.logo)}
        alt={view.name}
      />
      <div className={styles.poBody}>
        <div className={styles.poIntro}>
          <div
            className={styles.poName}
            style={{ color: productIconColor(view.logo) }}
          >
            {view.name}
          </div>
          <div className={styles.poSub}>
            {t('{{licenseType}}, billed {{cadence}}', {
              licenseType: t(licenseTypeLabel(view.licenseType)),
              cadence: t(billingCadence(view.billingPeriod)),
            })}
          </div>
        </div>
        <div className={styles.poControls}>
          <QuantityField
            value={view.quantity}
            minAmt={view.minAmt}
            maxAmt={view.maxAmt}
            onChange={(next) => dispatch(changeQuantity(view.ratePlan, next))}
          />
          <RemoveButton
            onClick={() => dispatch(removeProduct(view.ratePlan))}
          />
          <div className={styles.poPrice}>
            <PriceTag price={view.price} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default function ProductOverview() {
  const products = useAppSelector(selectCartProducts);
  const { t } = useTranslation();

  return (
    <section className={styles.step}>
      <h2 className={styles.stepTitle}>{t('Product Overview')}</h2>
      <div className={styles.overviewList}>
        {products.map((view) => (
          <ProductOverviewCard key={view.ratePlan} view={view} />
        ))}
      </div>
    </section>
  );
}
